import { collection, config, fields } from '@keystatic/core'
import { Link } from 'react-router'
import { Icon } from '#app/components/ui/icon.tsx'

export default config({
	storage: {
		// kind: 'local',
		kind: 'github',
		repo: 'clearwaterfarmsunit1/website',
	},
	ui: {
		brand: {
			name: 'Clearwater Farms',
			mark: () => (
				<Link to="/" className="h-20 w-20">
					<Icon name="cwf" aria-hidden="true" />
				</Link>
			),
		},
	},
	collections: {
		documents: collection({
			label: 'Documents',
			path: 'content/documents/*',
			slugField: 'title',
			format: { contentField: 'content' },
			schema: {
				title: fields.slug({ name: { label: 'Title' } }),
				content: fields.mdx({
					label: 'Content',
					options: {
						divider: true,
						link: true,
						image: {
							directory: 'public/documents',
							publicPath: '/documents',
						},
					},
				}),
				publishedOn: fields.date({
					label: 'Published On',
					validation: { isRequired: true },
				}),
			},
		}),
		agenda: collection({
			label: 'Agendas',
			path: 'content/agendas/*',
			slugField: 'title',
			format: { contentField: 'content' },
			schema: {
				title: fields.slug({ name: { label: 'Title' } }),
				content: fields.mdx({
					label: 'Content',
					options: {
						divider: true,
						link: true,
						image: {
							directory: 'public/agenda',
							publicPath: '/agenda',
						},
					},
				}),
				publishedOn: fields.date({
					label: 'Published On',
					validation: { isRequired: true },
				}),
			},
		}),
		minutes: collection({
			label: 'Minutes',
			path: 'content/minutes/*',
			slugField: 'title',
			format: { contentField: 'content' },
			schema: {
				title: fields.slug({ name: { label: 'Title' } }),
				content: fields.mdx({
					label: 'Content',
					options: {
						divider: true,
						link: true,
						image: {
							directory: 'public/minutes',
							publicPath: '/minutes',
						},
					},
				}),
				publishedOn: fields.date({
					label: 'Published On',
					validation: { isRequired: true },
				}),
			},
		}),
	},
})
